(function () {
  'use strict';

  function initRow(wrap) {
    if (wrap._posyInited) return;
    wrap._posyInited = true;
    var track = wrap.querySelector('[data-posy-row-track]');
    if (!track) return;
    var prev = wrap.querySelector('[data-posy-row-arrow="prev"]');
    var next = wrap.querySelector('[data-posy-row-arrow="next"]');

    function step() {
      var first = track.querySelector('.posy-product-card') || track.firstElementChild;
      if (!first) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseInt(styles.columnGap || styles.gap || 16, 10) || 16;
      var cardW = first.getBoundingClientRect().width;
      if (!cardW) return track.clientWidth * 0.8;
      var perView = Math.max(1, Math.round(track.clientWidth / (cardW + gap)));
      // 一次只滚动固定 N 张卡(默认 4)，避免一点就滑一整屏(perView)过快。
      // 不超过当前可见张数(窄屏 perView 小则按可见数)。可在 wrap 上加 data-step-cards 覆盖。
      var wantN = parseInt(wrap.getAttribute('data-step-cards'), 10) || 4;
      var count = Math.max(1, Math.min(wantN, perView));
      return (cardW + gap) * count;
    }
    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.toggleAttribute('disabled', track.scrollLeft <= 1);
      next.toggleAttribute('disabled', track.scrollLeft >= max);
    }
    // 对标 callie Swiper ~300ms：用 rAF 定时缓动(easeInOutQuad)替代浏览器可变的 scroll-behavior:smooth
    function animateScroll(to, dur) {
      var start = track.scrollLeft, delta = to - start, t0 = 0;
      function frame(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        track.scrollLeft = start + delta * e;
        if (p < 1) window.requestAnimationFrame(frame);
      }
      window.requestAnimationFrame(frame);
    }
    function scrollByStep(dir) {
      animateScroll(track.scrollLeft + dir * step(), 300);
    }
    if (prev) prev.addEventListener('click', function () { scrollByStep(-1); });
    if (next) next.addEventListener('click', function () { scrollByStep(1); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    // Drag to scroll（鼠标/触控笔）—— 触摸交给浏览器原生横滑，避免与惯性滚动打架。
    // 用 Pointer Events + setPointerCapture：达到阈值后捕获该指针，之后 pointermove/pointerup 一定回到
    // track —— 即使光标移出 track 甚至移出窗口也不丢事件，从结构上消除"松手后还跟手滚"的卡死态
    // (旧 mouse 版在原生拖拽时只收到 dragend 收不到 mouseup，down 卡 true 才会那样)。
    // 仍保留阈值：未超过阈值当作点击，不碰 snap/behavior、不捕获指针 → 保证点击能正常打开商品。
    var down = false, dragging = false, justDragged = false, startX = 0, startScroll = 0, ptrId = null;
    var pendingScroll = null, rafId = 0;
    var prevScrollBehavior = '', prevSnapType = '';
    var DRAG_THRESHOLD = 8;
    function flushScroll() {
      rafId = 0;
      if (pendingScroll == null) return;
      track.scrollLeft = pendingScroll;
      pendingScroll = null;
    }
    function beginDrag() {
      dragging = true;
      prevScrollBehavior = track.style.scrollBehavior;
      prevSnapType = track.style.scrollSnapType;
      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';
      track.classList.add('is-grabbing');
      try { track.setPointerCapture(ptrId); } catch (_) {}
    }
    function endDrag() {
      if (!down) return;
      down = false;
      if (rafId) { window.cancelAnimationFrame(rafId); rafId = 0; flushScroll(); }
      if (dragging) {
        justDragged = true;   // 这一程是真拖拽 → 抑制紧随的 click，避免拖完误跳商品
        try { track.releasePointerCapture(ptrId); } catch (_) {}
        window.requestAnimationFrame(function () {
          track.style.scrollBehavior = prevScrollBehavior;
          track.style.scrollSnapType = prevSnapType;
          track.classList.remove('is-grabbing');
        });
      }
      dragging = false;
      ptrId = null;
    }
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;            // 触摸：用浏览器原生横滑
      if (e.button != null && e.button !== 0) return;   // 仅主键(左键)
      down = true; dragging = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      ptrId = e.pointerId;
      // 此处不碰 snap/behavior，等真拖动(beginDrag)才改 —— 否则普通点击会被打断
    });
    track.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== ptrId) return;
      var dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;      // 未达阈值：当潜在点击，什么都不做(不捕获、不滚动)
        beginDrag();
      }
      pendingScroll = startScroll - dx;
      if (!rafId) rafId = window.requestAnimationFrame(flushScroll);
    });
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    // 关键：卡片是 <a> 包 <img>，浏览器默认会对它们启动原生 HTML5 拖拽(显示拖影)，会劫持指针、吞掉
    // pointermove，使拖动滚动失效。dragstart 冒泡到 track，preventDefault 即可禁掉；它只在真拖时触发，普通点击不受影响。
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    // 仅当确实拖过(justDragged)才拦 click；普通点击 justDragged=false → 正常跳转打开商品
    track.addEventListener('click', function (e) {
      if (justDragged) { e.preventDefault(); e.stopPropagation(); justDragged = false; }
    }, true);
  }

  function initAll() {
    document.querySelectorAll('[data-posy-row]').forEach(initRow);
  }

  // Recently Viewed: client populates from browse history
  var RV_KEY = 'posy-recently-viewed-v1';
  var RV_MAX = 12;

  function getRV() {
    try {
      var raw = localStorage.getItem(RV_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string' && h.length > 0; }) : [];
    } catch (_) { return []; }
  }
  function setRV(arr) {
    try { localStorage.setItem(RV_KEY, JSON.stringify(arr.slice(0, RV_MAX))); } catch (_) {}
  }
  function pushRV(handle) {
    if (!handle) return;
    var arr = getRV();
    arr = arr.filter(function (h) { return h !== handle; });
    arr.unshift(handle);
    setRV(arr);
  }

  // On product pages, record the current product handle
  function recordCurrentProduct() {
    var meta = document.querySelector('meta[name="posy-product-handle"]');
    var handle = meta && meta.content;
    if (!handle) {
      // Fallback: derive from URL /products/<handle>
      var m = (window.location.pathname || '').match(/\/products\/([^\/?#]+)/);
      handle = m && m[1];
    }
    if (handle) pushRV(handle);
  }

  function fetchProductHtml(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=card', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .catch(function () { return null; });
  }

  function hydrateRecentlyViewed() {
    var wraps = document.querySelectorAll('[data-recently-viewed]');
    if (!wraps.length) return;
    var handles = getRV();
    if (!handles.length) return;

    wraps.forEach(function (wrap) {
      var track = wrap.querySelector('[data-posy-row-track]');
      if (!track) return;

      // Filter out the current product if we're on a PDP
      var currentMatch = (window.location.pathname || '').match(/\/products\/([^\/?#]+)/);
      var currentHandle = currentMatch && currentMatch[1];
      var list = handles.filter(function (h) { return h !== currentHandle; });
      if (!list.length) return;

      Promise.all(list.map(fetchProductHtml)).then(function (parts) {
        var html = parts.filter(Boolean).join('');
        if (!html) return;
        track.innerHTML = html;
        // 对标 callie：Recently Viewed 默认隐藏，只有有浏览历史(已取到商品)时才显示
        var sec = wrap.closest('.posy-rv-section');
        if (sec) sec.classList.add('is-shown');
        // Reset arrow state for new content
        if (typeof Event === 'function') {
          window.dispatchEvent(new Event('resize'));
        }
      });
    });
  }

  function ready() {
    initAll();
    recordCurrentProduct();
    hydrateRecentlyViewed();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  // Re-init on Shopify section reloads
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
  }
})();
